import { render, staticRenderFns } from "./data14.vue?vue&type=template&id=6ede2abf&scoped=true"
import script from "./data14.vue?vue&type=script&lang=js"
export * from "./data14.vue?vue&type=script&lang=js"
import style1 from "./data14.vue?vue&type=style&index=1&id=6ede2abf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ede2abf",
  null
  
)

export default component.exports